import React, { useState, useEffect } from 'react';
import { 
  UserPlus, CheckCircle, TrendingUp, Award, 
  DollarSign, Clock, Star, Users, Briefcase,
  Zap, Shield, Target
} from 'lucide-react';
import '../../../../assets/css/subscreens/customer/home/worker section/JoinAsWorker.css';
import workersimage from '../../../../assets/images/reviews.jpg';
import WorkerRegister from '../../../../components/serviceprovider/workerauth/WorkerAuth';

const BENEFITS = [
  {
    icon: <TrendingUp size={28} />,
    title: 'Grow Your Business',
    description: 'Access thousands of customers actively looking for your services'
  },
  {
    icon: <DollarSign size={28} />,
    title: 'Earn More Money',
    description: 'Set your own rates and get paid directly for completed jobs'
  },
  {
    icon: <Star size={28} />,
    title: 'Build Your Reputation',
    description: 'Gain verified reviews and ratings to attract more clients'
  },
  {
    icon: <Clock size={28} />,
    title: 'Flexible Schedule',
    description: 'Work when you want and choose the jobs that suit you best'
  }
];

const STATS = [
  { value: '10K+', label: 'Active Jobs Monthly' },
  { value: 'Rs 50K+', label: 'Average Monthly Earnings' },
  { value: '4.8★', label: 'Provider Rating' },
  { value: '24/7', label: 'Support Available' }
];

const FEATURES = [
  { icon: <CheckCircle size={18} />, text: 'Instant job notifications' },
  { icon: <CheckCircle size={18} />, text: 'Professional profile dashboard' },
  { icon: <CheckCircle size={18} />, text: 'Verified customer reviews' },
  { icon: <CheckCircle size={18} />, text: 'Secure payment system' },
  { icon: <CheckCircle size={18} />, text: 'Marketing support' },
  { icon: <CheckCircle size={18} />, text: 'Free business tools' }
];

const JoinAsWorker = () => {
  const [isVisible, setIsVisible] = useState(false);
  // Modals
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showRegister, setShowRegister] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="join-worker-section">
      
      {/* Background Elements */}
      <div className="join-bg-pattern" />
      <div className="join-bg-circle join-bg-circle--1" />
      <div className="join-bg-circle join-bg-circle--2" />

      <div className="join-worker-container">
        
        {/* ═══ MAIN CONTENT GRID ═══ */}
        <div className="join-worker-grid">
          
          {/* ── Left Side - Content ── */}
          <div className={`join-worker-content ${isVisible ? 'slide-in-left' : ''}`}>
            
            {/* Badge */}
            <div className="join-badge">
              <Briefcase size={16} className="join-badge-icon" />
              <span className="join-badge-text">FOR PROFESSIONALS</span>
            </div>

            {/* Title */}
            <h1 className="join-title">
              Grow Your Business with Pics4Tips
            </h1>

            {/* Description */}
            <p className="join-description">


            Join the United States’ leading home services platform and connect with thousands of customers looking for your expertise. Whether you’re an electrician, plumber, painter, cleaner, or home shifting specialist, WorkHub helps you manage jobs, build your reputation, and grow your income across the U.S.


            </p>

            {/* Features List */}
            <div className="join-features">
              {FEATURES.map((feature, index) => (
                <div key={index} className="join-feature-item">
                  {feature.icon}
                  <span>{feature.text}</span>
                </div>
              ))}
            </div>

        <button
  onClick={() => setShowRegister(true)}
  className="join-cta-button"
>
  <UserPlus size={20} />
  <span>BECOME A PROVIDER</span>
</button>
            {/* Trust Badge */}
           
          </div>

          {/* ── Right Side - Image ── */}
          <div className={`join-worker-image ${isVisible ? 'slide-in-right' : ''}`}>
            <div className="join-image-wrapper">
              <img 
                src={workersimage}
                alt="Professional Workers"
                className="worker-main-image"
              />
              <div className="join-image-overlay" />
              
              {/* Floating Stats */}
              

              {/* <div className="join-floating-card join-floating-card--2">
                <div className="floating-card-icon">
                  <Users size={20} />
                </div>
                <div className="floating-card-content">
                  <div className="floating-card-value">10K+</div>
                  <div className="floating-card-label">Monthly Jobs</div>
                </div>
              </div> */}
            </div>
          </div>

        </div>

        {/* ═══ STATS SECTION ═══ */}
        {/* <div className={`join-stats ${isVisible ? 'fade-in-up' : ''}`}>
          {STATS.map((stat, index) => (
            <div key={index} className="join-stat-card">
              <div className="join-stat-value">{stat.value}</div>
              <div className="join-stat-label">{stat.label}</div>
            </div>
          ))}
        </div> */}

        {/* ═══ BENEFITS SECTION ═══ */}
        {/* <div className={`join-benefits ${isVisible ? 'fade-in-delayed' : ''}`}>
          <h3 className="join-benefits-title">Why Join Pics4Tips?</h3>
          <div className="join-benefits-grid">
            {BENEFITS.map((benefit, index) => (
              <div key={index} className="join-benefit-card">
                <div className="join-benefit-icon">
                  {benefit.icon}
                </div>
                <h4 className="join-benefit-title">{benefit.title}</h4>
                <p className="join-benefit-desc">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div> */}

        {/* ═══ BOTTOM CTA ═══ */}
        {/* <div className={`join-bottom-cta ${isVisible ? 'scale-in' : ''}`}>
          <div className="join-bottom-content">
            <div className="join-bottom-icon">
              <Target size={40} />
            </div>
            <h3 className="join-bottom-title">Ready to Start Earning?</h3>
            <p className="join-bottom-text">
              Join thousands of professionals already growing their business with Pics4Tips
            </p>
            <button 
              className="join-bottom-button"
              onClick={() => setShowWorkerModal(true)}
            >
              <span>Get Started Now</span>
              <Zap size={18} />
            </button>
          </div>
        </div> */}

      </div>

      {/* Modal */}
      {showRegister && (
        <WorkerRegister
          onClose={() => setShowRegister(false)}
          onSwitchToLogin={() => { 
            setShowRegister(false); 
            setShowLoginModal(true); 
          }}
        />
      )}
 
    </section>
  );
};

export default JoinAsWorker;